import {h} from 'preact';
import Icon from '@components/common/Icon';
import {cxMenu} from '../../styles';

const Header = ( {children} ) =>
    <li>
        <div data-action-back className={cxMenu.back}>
            <Icon.ui name="arrow-left" className="text-xl"/>
            <span className={cxMenu.backLabel}>
                {children}
            </span>
        </div>
    </li>;

export default Header;